import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { logout } from '@state/actions/users'
import i18n from '@localization/i18n'
import { useLanguage, useAppConfig } from '@state/uses/app'
import { getAppConfig } from '@state/actions/app'
export default ({ show, close }) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const language = useLanguage()

    const tmpAppConfig = useAppConfig()
    const [appConfig, setAppConfig] = useState(tmpAppConfig)
    useEffect(() => {
        if (!tmpAppConfig) {
            dispatch(getAppConfig(setAppConfig))
        } else {
        }
    }, [tmpAppConfig])
    const reciepientsList = appConfig?.contact_us_list

    function onProfileClick(event) {
        event.preventDefault()
        console.log('profile')
        history.push('user_profile')
    }

    function onLogoutClick(event) {
        close()
        dispatch(
            logout(() =>
                history.push({
                    pathname: '/login',
                })
            )
        )
    }

    function goToLandingPage(event) {
        history.push('/')
    }

    const contactUs = () => {
        window.location = 'mailto:' + reciepientsList
    }

    const padFrom = language === 'he' ? 'left' : 'right'

    return (
        <DropDown
            hebrew={language === 'he'}
            style={{
                visibility: show ? 'visible' : 'hidden',
                [padFrom]: '12px',
            }}>
            <DropDownItem onClick={contactUs}>
                {i18n.t('user_menu_headlines.contact_us')}
            </DropDownItem>
            <DropDownItem onClick={goToLandingPage}>
                {i18n.t('user_menu_headlines.main_page')}
            </DropDownItem>
            <DropDownItem onClick={onProfileClick}>
                {i18n.t('user_menu_headlines.profile')}
            </DropDownItem>
            <DropDownItem onClick={onLogoutClick}>
                {i18n.t('user_menu_headlines.logout')}
            </DropDownItem>
        </DropDown>
    )
}

const DropDown = styled.div`
    top: 52px;
    z-index: 1;
    height: auto;
    outline: none;
    min-width: 80px;
    padding: 4px 8px;
    position: absolute;
    background-color: #ffffff;
    border: 1px solid rgb(83, 71, 103);
    border-top: none;

    @media (max-width: 768px) {
        top: 50px;
    }
`

const DropDownItem = styled.div`
    // text-align: right;
    padding: 4px 0px;
    color: rgb(83, 71, 103);
`
